export const profileActivityData = [
    {
        type: 'success',
        leadDate: 'Reynante placed new order',
        date: '[April 19, 2023]',
        text: 'New order placed',
        linkText: '#456987',
        linkHref: '#',
    },
    {
        type: 'info',
        leadDate: '5+ friends join this group',
        date: '[April 20, 2023]',
        text: 'Joined the group',
        linkText: '"Duralux"',
        linkHref: '#',
    },
    {
        type: 'secondary',
        leadDate: 'Socrates send you friend request',
        date: '[April 21, 2023]',
        text: 'New friend request',
        linkText: 'Conform',
        linkHref: '#',
        badge: true,
        badgeColor: "success"
    },
    {
        type: 'warning',
        leadDate: 'Reynante make deposit $565 USD',
        date: '[April 22, 2023]',
        text: 'Make deposit',
        linkText: '"$565 USD"',
        linkHref: '#',
    },
    {
        type: 'primary',
        leadDate: 'New event are coming soon',
        date: '[April 23, 2023]',
        text: 'Attending the event ',
        linkText: '"Duralux Event"',
        linkHref: '#',
    },
    {
        type: 'info',
        leadDate: '5+ friends join this group',
        date: '[April 24, 2023]',
        text: 'Joined the group',
        linkText: '"Duralux"',
        linkHref: '#',
    },
    {
        type: 'danger',
        leadDate: 'New meeting joining are pending ',
        date: '[April 25, 2023]',
        text: 'Duralux meeting',
        linkText: 'Join',
        linkHref: '#',
        badge: true,
        badgeColor: "warning"
    },
    {
        type: 'info',
        leadDate: '5+ friends join this group',
        date: '[April 25, 2023]',
        text: 'Joined the group',
        linkText: '"Duralux"',
        linkHref: '#',
    },
    {
        type: 'secondary',
        leadDate: 'Socrates send you friend request',
        date: '[April 21, 2023]',
        text: 'New friend request',
        linkText: 'Conform',
        linkHref: '#',
        badge: true,
        badgeColor: "success"
    },
    {
        type: 'warning',
        leadDate: 'Reynante make deposit $565 USD',
        date: '[April 22, 2023]',
        text: 'Make deposit',
        linkText: '"$565 USD"',
        linkHref: '#',
    },
    {
        type: 'primary',
        leadDate: 'New event are coming soon',
        date: '[April 23, 2023]',
        text: 'Attending the event ',
        linkText: '"Duralux Event"',
        linkHref: '#',
    },
];

export const profileActivityData2 = [
    {
        color: 'primary',
        title: 'New orders placed #987456',
        description: 'Duralux is a clean bootstrap admin dashboard, frontend and webapps template pack that built with most popular bootstrap framework and modern technology\'s.',
        badges: [
            { text: 'design', color: 'success' },
            { text: 'html', color: 'danger' },
            { text: 'css', color: 'warning' },
            { text: 'dashboard', color: 'teal' }
        ],
        timeAgo: '5 min ago'
    },
    {
        color: 'success',
        title: 'New orders placed #987456',
        description: 'Duralux is a clean bootstrap admin dashboard, frontend and webapps template pack that built with most popular bootstrap framework and modern technology\'s.',
        badges: [
            { text: 'dashboard', color: 'teal' },
            { text: 'html', color: 'danger' },
            { text: 'design', color: 'success' },
            { text: 'css', color: 'warning' }
        ],
        timeAgo: '15 min ago'
    },
    {
        color: 'danger',
        title: 'Event start soon #Duralux',
        description: 'Duralux is a clean bootstrap admin dashboard, frontend and webapps template pack that built with most popular bootstrap framework and modern technology\'s.',
        badges: [
            {
                users: [
                    {
                        user_name: "Alex Curten",
                        user_img: "/images/avatar/1.png"
                    },
                    {
                        user_name: "Janette Dalton",
                        user_img: "/images/avatar/2.png"
                    },
                    {
                        user_name: "Mikal Bon",
                        user_img: "/images/avatar/3.png"
                    },
                    {
                        user_name: "Socrates Itumay",
                        user_img: "/images/avatar/4.png"
                    },
                    {
                        user_name: "Jakson Jak",
                        user_img: "/images/avatar/6.png"
                    },
                ]
            }
        ],
        timeAgo: '10 min ago'
    },
    {
        color: 'warning',
        title: 'Special promotion alert',
        description: 'Check out our special promotion for this week. Limited time offer!',
        badges: [
            { text: 'promotion', color: 'info' },
            { text: 'limited', color: 'warning' }
        ],
        timeAgo: '1 hour ago'
    },
];